// components/icons/PlusIcon.jsx
export default function PlusIcon({
  size = 16,
  stroke = "currentColor",
  className = "",
  title,
  ...props
}) {
  const ariaProps = title
    ? { role: "img", "aria-label": title }
    : { role: "presentation", "aria-hidden": true };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      focusable="false"
      {...ariaProps}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M14.125 7.344H8.656V1.875H7.344v5.469H1.875v1.312h5.469v5.469h1.312V8.656h5.469V7.344z"
        fill={stroke}
      />
    </svg>
  );
}
